'use strict';
import React from 'react';
import flux from 'utils/flux';
import AltFilterCategory from './altFilterCategory';
import _cloneDeep from 'lodash/lang/cloneDeep';

var AltFilters = React.createClass({
    displayName: 'AltFilters',
    mixins: [],
    propTypes: {},
    contextTypes: {
        router: React.PropTypes.func.isRequired
    },

    getInitialState() {
        return {
            filtersExpanded: false
        };
    },

    toogleExpand(e) {
        e.preventDefault();
        flux.getActions('media').toggleExpand();
    },
    clearFilters(e) {
        e.preventDefault();
        const query = {clearFlag: "true"};
        flux.getActions('media').clearQuery();

        this.context.router.transitionTo('landing-page', null, query);
    },
    toogleMoreFilters() {
        this.setState({filtersExpanded: !this.state.filtersExpanded});
    },
    render() {
        if (!this.props.filters || this.props.filters.size === 0) {
            return false;
        }
        var query = _cloneDeep(this.context.router.getCurrentQuery());
        const { router } = this.context;
        const route = router.getRouteAtDepth(1);
        const isLanding = route && 'landing-page' === route.name;
        const { hideFilters } = flux.getStore('app').getState();
        const limitNoOfFilters = this.props.limitNoOfFilters;
        let numberOfFiltersToShow = this.props.numberOfFilters;
        let numberOfValidFilters = 0;
        return (
            <div className="media__filters">
                {this.props.children}
                <h4>{flux.t('filter')}</h4>
                <div className="filters__buttons">
                    <button onClick={this.clearFilters} disabled={isLanding || query.hasOwnProperty('clearFlag')} type="button" className="btn btn-border buttons__clear">
                        <i className="close"></i>
                        {flux.t('clear_filters')}
                    </button>

                    <button type="button" onClick={this.toogleExpand} className="btn btn-border buttons__expand">
                        <i className="expand"></i>
                        {flux.t(this.props.isExpanded ? 'collapse_all' : 'expand_all')}
                    </button>
                </div>
                <div className="filters__categories">
                    {this.props.filters.map((filter, ix) => {
                      var filterName = filter.get('name').toLowerCase();
                        if (filter.get('hidden')) {
                            return false;
                        }
                        if (typeof hideFilters != 'undefined') {
                          if (hideFilters.indexOf(filterName) > -1) {
                            return false
                          }
                        }

                        numberOfValidFilters = numberOfValidFilters + 1;

                        if (numberOfFiltersToShow === 0 && !this.state.filtersExpanded && limitNoOfFilters) return false;

                        numberOfFiltersToShow = numberOfFiltersToShow - 1;

                        return <AltFilterCategory selectedFilters={this.props.selectedFilters} key={'filter_'+ix} query={query} ix={ix} filter={filter} filerHeight={this.props.filterHeight} />;
                    })}
                    {numberOfValidFilters > this.props.numberOfFilters && limitNoOfFilters &&
                        <div className="filters__buttons"><button type="button" onClick={this.toogleMoreFilters} className="btn btn-border buttons__expand-filters">
                            {flux.t(this.state.filtersExpanded ? 'less_filters' : 'more_filters')}
                        </button></div>
                    }
                </div>
            </div>
        );
    }
});

module.exports = AltFilters;



// WEBPACK FOOTER //
// ./app/pages/media/altFilters.jsx